<div id="app-question-content" class="question-content" *ngIf="question">
    <formio-loader></formio-loader>
    <h6>
        <div class="row">
            <div class="col-sm-6">
                <span [class.field-required]="question.isRequired">
                    <span>{{question.displayOrder}}</span>
                    <span class="separator"></span>
                    <span>{{question.name}}</span>
                </span>

                <br />
                <span *ngIf="question.hasError && question.value && !question.notApply" class="error">
                    {{question.error}}
                </span>
            </div>
            <div class="col-sm-6">
                &nbsp;&nbsp;<input type="checkbox" id="question_{{question}}" [(ngModel)]="question.notApply"
                    [disabled]="viewOnly" (change)="changeApply()">
                &nbsp;<label for="{{question._id}}"
                    [ngClass]="{'answered-label' : question.notApply && viewOnly}">{{'forms.common.a1' |
                    translate}}</label>
            </div>
        </div>

        <div class="info" *ngIf="question.tooltip" (click)="showDialog(question.tooltip)">
            <i class="fa fa-info"></i>
        </div>

    </h6>


    <form #form="ngForm">
        <ng-container>

            <ng-container *ngIf="processConfig.hasEvaluationItems">
                <br />
                <div class="evaluatedItems">
                    <table class="table table-bordered">
                        <tr class="header">
                            <th width="50%" rowspan="2"></th>
                            <th rowspan="2">{{'forms.common.a1' | translate}}</th>
                            <th *ngFor="let item of processConfig.evaluationLevels">
                                {{item.label}}
                            </th>
                        </tr>
                        <tr class="header">
                            <th *ngFor="let item of processConfig.evaluationLevels">
                                {{item.score}}
                            </th>
                        </tr>

                        <tr *ngFor="let item of question.evaluationItems;let i = index">
                            <td>
                                {{item.name}}
                                <i class="fas fa-info-circle iconTooltip" *ngIf="item.tooltip"
                                    [pTooltip]="item.tooltip"></i>

                                <br />
                                <span *ngIf="item.hasError && item.score" class="error">
                                    {{item.error}}
                                </span>
                            </td>
                            <td>
                                <input type="radio" id="notApply" id="ea-{{question._id}}-{{i}}"
                                    name="ea-{{question._id}}-{{i}}" value="" [(ngModel)]="item.score"
                                    [disabled]="viewOnly || question.notApply">
                            </td>
                            <td *ngFor="let option of processConfig.evaluationLevels;let il = index">
                                <input type="radio" id="{{question._id.substring(0,10)}}-{{i}}-{{il}}-{{option.id}}"
                                    name="{{question._id.substring(0,10)}}-{{i}}-{{il}}-{{option.id}}" [value]="option.score"
                                    [(ngModel)]="item.score" [disabled]="viewOnly || question.notApply">
                            </td>
                        </tr>
                    </table>
                </div>
                <br />
            </ng-container>


            <ng-container *ngIf="!processConfig.hasEvaluationItems">
                <br />
                <div class="answerContainer">
                    <div *ngFor="let item of answerArray" class="{{viewOnly || question.notApply ? 'disabled' : ''}}"
                        (click)="viewOnly || question.notApply ? null : anwserChange(item.value)"
                        [pTooltip]="item.tooltip" [tooltipDisabled]="viewOnly || question.notApply">
                        <input class="radio" type="radio" name="answer_{{question._id}}_{{item.value}}"
                            id="answer_{{question._id}}_{{item.value}}" value="{{item.value}}"
                            required="question.isRequired" [disabled]="viewOnly || question.notApply"
                            [(ngModel)]="question.value" matTooltip="{{'forms.common.answer_radio_tooltip_' + item.value | translate}}">
                        <label for="answer_{{question._id}}_{{item.value}}" matTooltip="{{'forms.common.answer_radio_tooltip_' + item.value | translate}}">
                            {{item.value}}
                        </label>
                    </div>
                </div>
                <br />
            </ng-container>

            <div class="row">
                <div class="col-sm-6" *ngIf="question.hasLink">
                    <label [class.field-required]="question.linkIsRequired">{{question.linkName}}</label>
                    <i class="fas fa-info-circle iconTooltip" *ngIf="question.linkTooltip"
                        [pTooltip]="question.linkTooltip"></i>
                    <div class="input-group">
                        <div class="input-group-prepend">
                            <span class="input-group-text">
                                <i class="fas fa-globe"></i>
                            </span>
                        </div>
                        <input type="text" class="form-control" [required]="question.linkIsRequired"
                            [pattern]="linkPattern" [disabled]="viewOnly || question.notApply" name="questionLink"
                            #questionLink="ngModel" [(ngModel)]="question.linkValue" />
                    </div>
                    <span *ngIf="questionLink.touched && questionLink.errors?.pattern"
                        class="error">{{'forms.common.pattern' | translate}}</span>
                </div>

                <div class="col-sm-12" *ngIf="question.hasNotes">
                    <br />
                    <label [class.field-required]="question.notesIsRequired">{{question.notesName}}</label>
                    <i class="fas fa-info-circle iconTooltip" *ngIf="question.notesTooltip"
                        [pTooltip]="question.notesTooltip"></i>
                    <div class="wrapFlex">
                        <div class="avatar userAvatar"></div>
                        <div class="notesContainer notes m-start" [dir]="dir">
                            <div class="box sb1 {{viewOnly || question.notApply ? 'readOnlyEditor' : ''}}">
                                <!-- <textarea class="form-control m-b-5" [required]="question.notesIsRequired"
                                    name="questionNotes" [(ngModel)]="question.notesValue"
                                    [disabled]="viewOnly || question.notApply"></textarea> -->

                                <p-editor name="questionNotes" [style]="{'height':'320px'}"
                                    [required]="question.notesIsRequired" [(ngModel)]="question.notesValue"
                                    [readonly]="viewOnly || question.notApply">
                                </p-editor>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="col-sm-12" *ngIf="question.hasAttachments">
                    <br />
                    <div class="wrapFlex align-center" *ngIf="question.attachmentsTooltip">
                        <i class="fas fa-info-circle largeIcon"></i>
                        <span class="hint">{{question.attachmentsTooltip}}</span>
                    </div>

                    <ng-container *ngFor="let item of question.attachments">
                        <div *ngIf="formReady" class="card {{showForm ? '' : 'd-none'}}">
                            <div>
                                <label class="label" [class.field-required]="item.attachmentIsRequired">
                                    {{item.name | translate}}
                                </label>
                                <i class="fas fa-info-circle iconTooltip" *ngIf="item.tooltip"
                                    [pTooltip]="item.tooltip"></i>
                            </div>
                            <formio style="margin-top: -20px;" #forms [submission]="{data:{attachments : item.data }}"
                                formKey="indicatorattachments" [showLoader]="false" (formLoad)="formLoad($event)"
                                [readOnly]="viewOnly || question.notApply" [viewOnly]="viewOnly || question.notApply">
                            </formio>
                            <!-- <formio style="margin-top: -20px;" #forms [id]="domain.id" [submission]="{data:{attachments : domain.attachmentsInstance }}"
                            [formKey]="data.indicator.attachmentsFormKey" [showLoader]="false" (formLoad)="formLoad($event)"
                            [readOnly]="data.options.disableAttachments || domain.decision == indicatorStatus.Completed"
                            [viewOnly]="data.options.disableAttachments || domain.decision == indicatorStatus.Completed">
                        </formio> -->
                        </div>
                        <br />
                    </ng-container>
                </div>

                <div class="col-sm-12" *ngIf="question.hasPledgeAndAcknowledgment">
                    <br />
                    <ng-container *ngIf="question.pledgeTooltip">
                        <i class="fas fa-info-circle iconTooltip"></i>
                        <label>{{question.pledgeTooltip}}</label>
                        <br />
                    </ng-container>
                    <span *ngIf="question.pledgeIsRequired" class="red">*</span>
                    <input type="checkbox" id="pledge_{{question._id}}" name="pledge_{{question._id}}"
                        [(ngModel)]="question.pledgeValue" [required]="question.pledgeIsRequired"
                        [disabled]="viewOnly || question.notApply">
                    &nbsp;
                    <label for="pledge_{{question._id}}" [innerHTML]="question.pledgeName">
                    </label>
                </div>


            </div>
        </ng-container>

        <br />
        <div [style.textAlign]="'end'" *ngIf="!viewOnly">
            <button type="button" class="dialog-button dialog-save" (click)="saveQuestion()"
                [disabled]="((form.invalid || !question.attachmentsValid || question.hasError) && !question.notApply) || formioLoader.loading">
                {{'forms.common.Save' |translate}}</button>
        </div>
        <!-- {{form.valid | json}} -->
    </form>
</div>